import { Client, RequestPolicy } from "urql";
import { SongFieldsFragmentDoc, SongUb } from "../gql/graphql";
import { useFragment } from "../gql";
import {
  songsIdsQuery,
  songsDeltaQuery,
  songsFullQuery,
} from "../items/songQueries";

export { songsIdsQuery, songsDeltaQuery, songsFullQuery };

export function fetchSongsIds(graphQlClient: Client): Promise<void> {
  return graphQlClient
    .query(songsIdsQuery, {}, { requestPolicy: "network-only" })
    .toPromise()
    .then((result) => {
      if (result.error === undefined && result.data && result.data.songs) {
        return Promise.resolve();
      } else {
        return Promise.reject(result);
      }
    });
}

export function fetchSongsDelta(
  graphQlClient: Client,
  updatedSince?: string,
): Promise<SongUb[]> {
  return graphQlClient
    .query(songsDeltaQuery, { updatedSince }, { requestPolicy: "network-only" })
    .toPromise()
    .then((result) => {
      if (result.error === undefined && result.data && result.data.songs) {
        const songs = useFragment(SongFieldsFragmentDoc, result.data.songs);
        return Promise.resolve(songs);
      } else {
        return Promise.reject(result);
      }
    });
}

export function fetchSongsFull(
  graphQlClient: Client,
  requestPolicy: RequestPolicy = "cache-only",
): Promise<SongUb[]> {
  return graphQlClient
    .query(songsFullQuery, {}, { requestPolicy })
    .toPromise()
    .then((result) => {
      if (result.error === undefined && result.data && result.data.songs) {
        const songs = useFragment(SongFieldsFragmentDoc, result.data.songs);
        return Promise.resolve(songs);
      } else {
        return Promise.reject(result);
      }
    });
}
